import { useQuery } from '@tanstack/react-query';
import { fetchBobinsState } from '../api/bobins';

export function useBobinsState({ includePlanned = false } = {}) {
  return useQuery({
    // include the flag in the key so the plan-ahead view caches separately and
    // callers without it are unaffected
    queryKey: ['projects', 'bobins-state', { includePlanned }],
    queryFn: () => fetchBobinsState(includePlanned),
    refetchInterval: 5000,
    staleTime: 0
  });
}
